export const AttentionBubble = () => {
  return (
    <div
      data-testid="attention-bubble"
      className="absolute -right-1 -top-2 inline-flex"
    >
      <div className="absolute inline-flex size-2.5 animate-ping rounded-full bg-accent-orange opacity-75" />
      <div className="relative inline-flex size-2.5 rounded-full bg-accent-orange" />
    </div>
  );
};
